module.exports = __webpack_public_path__ + "img/witti_logo.fecba07b.png";